<template>
  <div class="contenedor-difusion">
    <section class="contenedor-c">
      <div class="contenedor-titulo">
        <h1>Guía para la enseñanza</h1>
        <div class="barra"></div>
      </div>
      <section class="contenedor-login">
        <div class="contenedor-difusion-imagen">
          <img src="@/assets/guruji.jpg" alt="Guruji Iyengar">
        </div>
        <div class="contenedor-seminario">
          <h2 class="titulo_beneficios">Profesores Nivel I y II</h2>
          <ul class="lista_precios_seminario">
            <li><span>&#8226;</span><b> Clases Generales:</b> Las personas certificadas en Nivel I y II están habilitadas para impartir clases generales, es decir, aquellas que no sean terapéuticas. Estas clases deben ajustarse al silabario correspondiente a su nivel de certificación y no mezclar otros métodos de enseñanza. Es fundamental respetar la evolución de cada estudiante, ajustándose a sus necesidades sin forzar el aprendizaje.</li>
            <li><span>&#8226;</span><b> Abordajes Terapéuticos:</b> Aunque quienes están certificados en Nivel I y II, pueden abordar problemas comunes dentro de sus clases (dolor de cuello, hombros, espalda baja o rodillas), no están habilitados a ofrecer clases específicas para tratar estos problemas. Si un estudiante requiere atención terapéutica, deberá ser derivado a una persona certificada en Nivel III o superior, o trabajar bajo su guía.</li>
            <li><span>&#8226;</span><b> Embarazo:</b> Profesores de Nivel I y II no están autorizados para impartir clases específicas para embarazadas. Sin embargo, pueden continuar guiando a sus alumnas regulares que han quedado embarazadas, siempre que se trate de embarazos sin complicaciones. Si hay complicaciones, deben remitirse a una persona certificada en Nivel III o superior y trabajar bajo su supervisión. </li>
          </ul>
        </div>
      </section>
    </section>
  </div>
</template>
<script>
import store from './../store'
export default {
  name: 'GuiaEnseñanza',
  components: {
  },
  data: function () {
    return {
      store
    }
  },
  methods: {
  },
  mounted: function () {
  }
}
</script>
<style>

</style>
